var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"dom_width"},_vm._l((_vm.listImg),function(item,index){return _c('img',{key:index,staticClass:"img_block",attrs:{"src":item,"alt":""}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }